import React, { useState } from 'react';
import { Dialog } from "@primer/react/drafts";
import {
  Box,
  Text,
  TextInput,
  FormControl,
  Button,
  ButtonGroup,
  Textarea
} from "@primer/react";
import { useForm } from "react-hook-form";
import { useCommonContext } from '../../../../contexts/common';
import { danhSachThiApi } from '../../../../api/danhSachThiApi';
import { NotifyHelper } from '../../../../helpers/toast';

interface ChiaPhongModalProps {
  tong_thi_sinh: number;
  is_show_model: boolean;
  ex_kythi_monthi_id?: number;
  ex_thisinh_ids?: number[];
  pl_phonghoc_ids?: number[];
  onCancel: () => void;
  onSuccess: () => void;
}

interface FormData {
  so_thisinh_chia: number;
  ghi_chu_thisinh: string;
  ghi_chu_phongthi: string;
}

const ChiaPhongModal: React.FC<ChiaPhongModalProps> = ({
  tong_thi_sinh,
  is_show_model,
  ex_kythi_monthi_id = 0,
  ex_thisinh_ids = [],
  pl_phonghoc_ids = [],
  onCancel,
  onSuccess
}) => {
  const { translate } = useCommonContext();
  const [isSaving, setIsSaving] = useState(false);

  const { register, handleSubmit, formState: { errors } } = useForm<FormData>({
    defaultValues: {
      so_thisinh_chia: 0,
      ghi_chu_thisinh: '',
      ghi_chu_phongthi: ''
    }
  });

  const onSubmit = async (formData: FormData) => {
    setIsSaving(true);
    try {
      const res = await danhSachThiApi.addOrUpdatePhongThiThiSinh({
        ...formData,
        ex_kythi_monthi_id,
        ex_thisinh_ids,
        pl_phonghoc_ids,
      });

      if (res.is_success) {
        NotifyHelper.Success(translate('Chia phòng thành công'));
        onSuccess();
        onCancel();
      } else {
        NotifyHelper.Error(res.message || translate('Có lỗi xảy ra'));
      }
    } catch (error) {
      NotifyHelper.Error(translate('Có lỗi xảy ra'));
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Dialog
      //open={is_show_model}
      onClose={onCancel}
      title={translate('Chia phòng thi')}
      width="medium"
    >
      <Box as="form" onSubmit={handleSubmit(onSubmit)} sx={{ p: 0 }}>
        <FormControl sx={{ mb: 3 }}>
          <FormControl.Label>
            {translate('Số thí sinh của mỗi phòng thi')}
          </FormControl.Label>
          <TextInput
            type="number"
            {...register('so_thisinh_chia', {
              required: true,
              min: 1,
              max: tong_thi_sinh || 999
            })}
            block
          />
          {/* {errors.so_thisinh_chia && (
            <FormControl.Error>
              {translate('Vui lòng điền số thí sinh của mỗi phòng thi')}
            </FormControl.Error>
          )} */}
        </FormControl>

        <FormControl sx={{ mb: 3 }}>
          <FormControl.Label>
            {translate('Ghi chú dành cho thí sinh')}
          </FormControl.Label>
          <Textarea
            {...register('ghi_chu_thisinh')}
            block
            rows={4}
          />
        </FormControl>

        <FormControl sx={{ mb: 3 }}>
          <FormControl.Label>
            {translate('Ghi chú dành cho phòng thi')}
          </FormControl.Label>
          <Textarea
            {...register('ghi_chu_phongthi')}
            block
            rows={4}
          />
        </FormControl>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <ButtonGroup>
            <Button onClick={onCancel}>
              {translate('Đóng')}
            </Button>
            <Button 
              variant="primary" 
              type="submit"
              disabled={isSaving}
            >
              {translate('Chia phòng')}
            </Button>
          </ButtonGroup>
        </Box>
      </Box>
    </Dialog>
  );
};

export default ChiaPhongModal;